import React from 'react';
import TagMoveButtons from './TagMoveButtons';
import TagDeleteButton from './TagDeleteButton';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import TagRenameField from './TagRenameField';
import TagEditColorButton from './TagEditColorButton';

type TagEditContentProps = { tag: Tag; shareRootPath: ImMNElement[]; closePopup: () => void };

const TagEditContent: React.FC<TagEditContentProps> = (props) => {
    const { tag, closePopup, shareRootPath } = props;

    if (!tag) return null;

    return (
        <div className="MobileTagEditContent">
            <TagMoveButtons tag={tag} shareRootPath={shareRootPath} />
            <TagDeleteButton tag={tag} closePopup={closePopup} />
            <TagRenameField tag={tag} closePopup={closePopup} />
            <TagEditColorButton tag={tag} />
        </div>
    );
};

export default TagEditContent;
